import React from "react";
import { buildImageStylesheet } from "./ElementImageStyleResolver";
import BuilderStyleTag from "../shared/BuilderStyleTag";

const ElementImage = (props) => {
  let element = props.element;
  const stylesheet = buildImageStylesheet(
    props.builder,
    props.device,
    props.cta,
    element
  );

  const altText = element.options["alt-text"]

  if (altText && props.builder !== true) {
    element.html = element.html.replace(/<img([^>]*)>/g, (match, p1) => {
      if (match.includes('alt="')) {
        return match.replace(/alt="([^"]*)"/, `alt="${altText}"`);
      } else {
        return `<img${p1} alt="${altText}">`;
      }
    });
  }

  if (element.options["image-link"] && props.builder !== true) {
    const imageLink = element.options["image-link"].indexOf("http") > -1 ? element.options["image-link"] : `http://${element.options["image-link"]}`;  
    const imageLinkNewTab = element.options["image-link-new-tab"] ? element.options["image-link-new-tab"] : false;

    element.html = element.html.replace(/<img([^>]*)>/g, (match, p1) => {
      return `<a href="${imageLink}" target="${imageLinkNewTab ? "_blank" : "_self"}"><img${p1}></a>`;
    });
  }

  return (
    <React.Fragment>
      <div
        id={"element" + element.id + "-content"}
        className="element-content cf-text-element cf-image cf-merge-tag-allowed"
        dangerouslySetInnerHTML={{
          __html:
            props.builder == true
              ? "<div class='froala-editor'>" + element.html + "</div>"
              : element.html,
        }}
      ></div>
      <BuilderStyleTag
        builder={props.builder}
        styleKey={`cta:${props.cta.id}:element:${element.id}:image`}
        stylesheet={stylesheet}
      />
    </React.Fragment>
  );
};

export default ElementImage;
